export const MIXPANEL_LESSON_TYPE = {
  NONE: "None",
  STUDENT_VOICE: "Student Voice",
  POSITIVE_PATHWAYS: "Positive Pathways",
  BRAIN_BREAK: "Brain Break",
  SKILL_BUILDER: "Skill-Builder",
  EDUCATOR_CONTENT: "Educator Content",
  RESOURCE: "Resource",
  CAREGIVER: "Caregiver",
  QUIZ: "Quiz",
  ONBOARDING: "Onboarding",
  /** Canonical label — matches SuperAdmin / lessonTypeOptions ("Student Introduction") */
  STUDENT_INTRODUCTION: "Student Introduction",
  /** Curriculum lessons inside a Unit/Course (no SuperAdmin lessonType) */
  UNIT: "Unit",
} as const;

/** Fallback when a Mixpanel filter property has no source value (avoids "(not set)") */
export const MIXPANEL_NONE = "None";

export const MIXPANEL_PROGRAM_TYPE = {
  EDUCATOR_WELL_BEING_SERIES: "Educator Well-Being Series",
  STUDENT_INTRODUCTION: "StudentIntroduction",
  STUDENT_VOICE_SERIES: "Student Voice Series",
  LESSON_LIBRARY: "Lesson Library",
  PROFESSIONAL_DEVELOPMENT: "Professional Development",
  TRANSITIONS: "Transitions",
  BRAIN_BREAKS: "Brain Breaks",
  SKILL_BUILDERS: "Skill Builders",
  EDUCATOR_WELLBEING: "Educator Wellbeing",
  CREATING_RESILIENT_CLASSROOMS: "Creating Resilient Classrooms",
  CAREGIVER: "Caregiver",
} as const;
